<ng-container *ngIf="{
  request: requestPowerData$ | async,
  isLoading: isLoading$ | async,
} as resolver">
<ng-container *ngIf="powerData$ | async as powerData; else noDataSkeleton">
  <section
    id="calendar-picker"
    class="w-full fx-row fx-gap-3 fx-center">
    <calendar-picker
      startView="month"
      [disabled]="resolver.isLoading || false"
      (dateSelected)="dateSelection$.next($event)">
      <button
        *ngIf="powerData.echartsOption.hasValues && system?.source === 'aws'"
        class="custom-mat-button-primary ml-0 custom-mat-button-border"
        mat-button
        (click)="onExport(powerData.echartsOption.graph.series)">
        <mat-icon class="m-0">download</mat-icon>
      </button>
      <button
        class="custom-mat-button-primary ml-0 custom-mat-button-border"
        mat-button
        [disabled]="!powerData.echartsOption.hasValues"
        (click)="toggleZoom()">
        <mat-icon class="m-0">{{ zoomed ? 'zoom_out' : 'zoom_in' }}</mat-icon>
      </button>
    </calendar-picker>
    <button
      *ngIf="compareGraphs"
      class="ml-0 custom-mat-button-border"
      [ngClass]="{
        'custom-mat-button-primary': compareGraphs === 'add',
        'custom-mat-button-warning': compareGraphs === 'close'
      }"
      mat-button
      (click)="compareGraphs === 'add'
        ? onShowCompareGraphEvent.emit('add')
        : onShowCompareGraphEvent.emit('close')">
      <mat-icon class="s-6 mr-0">
        {{ compareGraphs === 'add' ? 'add_circle' : 'close' }}
      </mat-icon>
  </button>
  </section>
  <lib-block-title
    id="power-title"
    [class.hidden]="!showTitle"
    [title]="labels.title">
  </lib-block-title>
  <app-custom-source-selector
    *ngIf="sourceOptions$ | async as sourceOptions"
    id="source-selector"
    [source]="sourceSelection$.value"
    [options]="sourceOptions"
    (selection)="updateSourcesSelection($event)">
  </app-custom-source-selector>
  <div
    *ngIf="powerData.echartsOption.hasValues; else noData"
    id="power-chart"
    class="w-full block-bg-contrast h-100"
    echarts
    [options]="powerData.echartsOption.graph"
    (chartInit)="onChartInit($event)">
  </div>

  <ng-template #noData>
    <div
      id="power-chart"
      class="w-full block-bg-contrast fx-col fx-center fx-gap-3 h-100">
      <mat-icon
        class="s-20"
        svgIcon="no_data">
      </mat-icon>
      <span class="text-grey-400 tw-font-normal tw-text-base">
        {{ labels.noDataForTheSelectedPeriod }}
      </span>
    </div>
  </ng-template>

  <section
    id="inner-content"
    class="fx-col fx-gap-3">
    <ng-container *ngFor="let attributes of chartsOpts$ | async; let index = index">
      <div class="fx-col fx-gap-3 bg-grey-100 tw-p-2 radius-4">
        <div class="fx-row fx-wrap fx-justify-around fx-align-center fx-gap-3">
          <ng-container *ngTemplateOutlet="attributeSelectorTemplate; context: {
            index: index,
            selected: attributes.chartsAttributes,
            disabled: resolver.isLoading,
            mode: 'update',
            powerData: powerData
          }"></ng-container>
          <button
            class="custom-mat-button-primary ml-0 custom-mat-button-border"
            mat-button
            (click)="onExport(attributes.chartOpts.series)">
            <mat-icon class="m-0">download</mat-icon>
          </button>
        </div>
        <div
          class="w-full block-bg-contrast h-80"
          echarts
          (chartInit)="onChartInit($event)"
          [options]="attributes.chartOpts">
        </div>
      </div>
    </ng-container>
    <div class="fx-row fx-wrap fx-justify-around fx-align-center fx-gap-3">
      <ng-container *ngTemplateOutlet="attributeSelectorTemplate; context: {
        selected: [],
        disabled: resolver.isLoading,
        mode: 'create',
        powerData: powerData
      }"></ng-container>
    </div>
  </section>
</ng-container>

<ng-template
  #attributeSelectorTemplate
  let-selected="selected"
  let-mode="mode"
  let-index="index"
  let-disabled="disabled"
  let-powerData="powerData">
  <ng-container *ngIf="attributesConfig$ | async as attributesByCat">
    <mat-form-field
      subscriptSizing="dynamic"
      class="custom-mat-form-field fx-g-1 fx-b-0 min-w-75 custom-border-bottom">
      <mat-select
        #devicesAttributes
        multiple
        placeholder="Select inverter measurements"
        [compareWith]="compareFn"
        [disabled]="disabled ?? false"
        [value]="selected ?? []">
        <ng-container *ngFor="let byCategory of attributesByCat; let first = first">
          <div
            class="tw-text-base text-font-medium p-3 bg-grey-100 text-grey-400"
            [ngClass]="{
              'mb-3': first,
              'my-3': !first
            }">
            {{ labels[byCategory.categoryId] }}
          </div>
          <div class="mat-option-list px-3">
            <ng-container *ngFor="let attr of byCategory.attributes">
              <mat-option
                *ngIf="{ value: devicesAttributes.value | apply : isAttributeOptDisabled : attr } as isDisabled"
                class="tw-tabular-nums tw-font-normal tw-text-base text-grey-400"
                [matTooltip]="isDisabled.value ? labels['youCanAddPropertiesForUpToTwoUnitsOfMeasurement'] : ''"
                [disabled]="devicesAttributes.value | apply : isAttributeOptDisabled : attr"
                [value]="attr">
                {{ labels[attr.id] }}
              </mat-option>
            </ng-container>

          </div>
        </ng-container>
        <div
          *ngIf="{
            hasSelectedAttributes: devicesAttributes.value?.length,
            hasTelemetryData: powerData?.powers?.length
          } as resolver"
          class="fx-row fx-wrap fx-justify-end fx-align-center fx-gap-3 p-3 bg-white inset-b-0 pos-sticky bg-opacity-70">
          <button
            class="custom-mat-button-warning"
            mat-button
            [disabled]="!resolver.hasSelectedAttributes"
            (click)="devicesAttributes.writeValue([])">
            {{ labels.clear }}
          </button>

          <button
            *ngIf="mode === 'update'"
            class="custom-mat-button-primary ml-0"
            mat-button
            [disabled]="!resolver.hasSelectedAttributes || !resolver.hasTelemetryData"
            (click)="
              updateChart(index, devicesAttributes.value);
              devicesAttributes.close();
              ">
            <mat-icon class="s-6">
              edit
            </mat-icon> {{ labels.updateChart }}
          </button>
          <button
            *ngIf="mode === 'create'"
            class="custom-mat-button-primary ml-0"
            mat-button
            [disabled]="!resolver.hasSelectedAttributes || !resolver.hasTelemetryData"
            (click)="
              addChart(devicesAttributes.value);
              devicesAttributes.writeValue([]);
              devicesAttributes.close();
              ">
            <mat-icon class="s-6">
              add_circle
            </mat-icon>{{ labels.createChart }}
          </button>
        </div>
      </mat-select>
    </mat-form-field>
    <button
      *ngIf="mode === 'update'"
      class="custom-mat-button-warning"
      mat-button
      (click)="deleteChart(index)">
      <mat-icon class="s-6">
        delete_forever
      </mat-icon> {{ labels.deleteChart }}
    </button>
  </ng-container>
</ng-template>

<ng-template #noDataSkeleton>
  <ion-skeleton-text
    id="power-title"
    class="w-42 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="calendar-picker"
    class="w-90 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="source-selector"
    class="w-full h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="power-chart"
    class="w-full h-100"
    [animated]="true">
  </ion-skeleton-text>
</ng-template>
</ng-container>
